import React, { Component } from 'react';
import styled from 'styled-components';

import Text from '../Styled/Text';
import Closer from './Closer';
import { getEmbedCode } from '../Sharing/ShareUtils';

const EmbedCode = styled.div`
  background: #eee;
  border: 0;
  white-space: pre-wrap;
  font-family: monospace;
  padding: 1em;
  word-break: break-all;
  font-size: 12px;
  margin-top: 10px;
`;

class Embed extends Component {
  render() {
    return (
      <div>
        <Closer setInfoboxContent={this.props.setInfoboxContent} />
        <Text>
          Mit diesem Code können Sie die Grafik &quot;{config.headline}&quot;
          kostenlos in Ihre Website einbetten.
        </Text>
        <EmbedCode>
          <code>{getEmbedCode()}</code>
        </EmbedCode>
      </div>
    );
  }
}

export default Embed;
